import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IAttachFilesExecutorProps } from './IAttachFilesExecutorProps';
import { AttachFilesExecutorModal } from './AttachFilesExecutorModal';

export const AttachFilesExecutor = createDocModalExecutor<IAttachFilesExecutorProps>({
    modal: AttachFilesExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        action: action,
        completeHandler,
    }),
});
